import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as actions from "redux/actions/noteActions";
import { Translate } from "react-redux-i18n";
import MiniLoader from "components/MiniLoader";

const List_ = (props) => {
    const selectedId = props.item && props.item.id;

    return (
        <aside className="knowledge-sidebar">
            <div className="knowledge-sidebar-scroll">
                <ul className="knowledge-notes-list">
                    {props.list.map((item, index) => (
                        <li
                            className={`list-item${selectedId === item.id ? " selected" : ""}`}
                            key={item.id || index}
                            onClick={() => { props.onClick(item); }}
                        >
                            <span>{item.title}</span>
                        </li>
                    ))}
                </ul>
                {props.pageSize === 25 && (
                    props.loadingMore ? (
                        <MiniLoader />
                    ) : (
                        <div className="knowledge-load-more">
                            <button
                                className="btn btn-primary"
                                type="button"
                                onClick={() => props.loadList({
                                    id: props.user_id,
                                    page: props.pageCount + 1
                                }, props.token)}
                            >
                                <Translate value="load_more" />
                            </button>
                        </div>
                    )
                )}
            </div>
        </aside>
    );
};

List_.propTypes = {
    className: PropTypes.string,
    history: PropTypes.object
};

function mapStateToProps(reducer) {
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,
        list: reducer.note.list,
        loading: reducer.note.loading,
        error: reducer.note.error,
        item: reducer.note.item,
        pageCount: reducer.note.page_count,
        pageSize: reducer.note.page_size,
        loadingMore: reducer.note.loadingMore,
    };
}

const mapDispatchToProps = dispatch => ({
    loadList: (params, token) =>
        dispatch(actions.loadList({ params, token })),
    setItem: (item) =>
        dispatch(actions.setItem({ item })),
});

export default connect(mapStateToProps, mapDispatchToProps)(List_);
